<template>
  <div class="c-item-wrap" @click="clickHandle">
    <div class="c-order-no">
      <div>NO：{{item.orderNo}}</div>
      <!-- 已付款、已完成、退款中、已退款 -->
      <div>{{constants.orderStatus[item.orderStatus]}}</div>
    </div>
    <div class="c-item">
      <div class="c-thumb c-default-img">
        <img :src="item.goodsImage" />
      </div>
      <div class="c-other ml30">
        <div class="c-title thidden">{{item.goodsName}}</div>
        <div class="c-uname thidden" v-if="item.userName">昵称：{{item.userName}}</div>
        <div class="c-date-info">
          <div>
            <span>{{formatDate(item.ct, 'yyyy.MM.dd')}}</span>
            <span class="pl32">{{formatDate(item.ct, 'hh:mm:ss')}}</span>
          </div>
          
          <!-- 已付款、已完成、退款中、已退款 -->
        </div>
        <div class="c-price">
          <div>实付：</div>
          <div class="c-price-num">
            <span>￥</span>
            {{item.payMoney}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dates from '@/utils/dates'
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  emits: ['click'],
  methods: {
    formatDate(ct, format) {
      return dates.formatDate(ct, format)
    },
    clickHandle() {
      this.$emit('click', this.value)
    },
  },
}
</script>

<style lang="less" scoped>
.c-item-wrap {
  text-align: left;
  width: 686px;
  margin: 0 auto 20px;
  background: #ffffff;
  border-radius: 10px;
  padding: 0 28px 30px;
}
.c-order-no {
  display: flex;
  justify-content: space-between;
  padding: 28px 0 32px;
  font-size: 28px;
  font-weight: 500;
  color: #aaaaaa;
}
.c-other {
  flex: 200px 0 0;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
}
.c-date-info {
  // padding: 28px 0 32px;
  font-size: 28px;
  font-weight: 500;
  color: #aaaaaa;
  line-height: 28px;
  display: flex;
  justify-content: space-between;
}
.c-item {
  display: flex;

  .c-thumb {
    flex: 150px 0 0;
    height: 200px;
    border-radius: 10px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .c-title {
    width: 450px;
    font-size: 30px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  .c-price {
    display: flex;
    // padding-top: 116px;
    // padding-top: 20px;
    color: #333;
    font-size: 26px;
    font-weight: bold;
    line-height: 26px;
    .c-price-num {
      font-size: 40px;
      color: #f50;
    }
  }
  .c-uname {
    width: 450px;
    font-size: 26px;
    font-weight: bold;
    line-height: 26px;
  }
}
</style>